import { ThemeColors } from '~/themes/colors'

interface BackgroundColors {
  Background: {
    Steady: ThemeColors
    Pulse: ThemeColors
  }
}

interface CircleBadgeColors {
  Blue: BackgroundColors
  Green: BackgroundColors
  Red: BackgroundColors
  Gray: BackgroundColors
}
export const circleBadgeColors: CircleBadgeColors = {
  Blue: {
    Background: {
      Steady: { default: 'blue.700' },
      Pulse: { default: 'mask.blue.700.50' },
    },
  },
  Green: {
    Background: {
      Steady: { default: 'green.600' },
      Pulse: { default: 'mask.green.600.50' },
    },
  },
  Red: {
    Background: {
      Steady: { default: 'red.700' },
      Pulse: { default: 'mask.red.700.50' },
    },
  },
  Gray: {
    Background: {
      Steady: { default: 'gray.700' },
      Pulse: { default: 'mask.gray.700.50' },
    },
  },
}
